export const tr = {
    'error-401': 'Bu işlem için gerekli yetkiniz yok',
    'error-429': 'Maksimum sorgu sayısı aşıldı. Lütfen, birazdan tekrar deneyin.'
};
